import {useEffect, useState} from 'react';
import {usePageTitle} from '../hooks/use-page-title'
import {ProfileForm} from '../profile/profile-form';
import {AccountData} from './profile';
import {SelectItem} from '@mantine/core';
import {useLazyListenerQuery} from "../store/slice/customApiSlice";

export const EditProfile = () => {
  const [advocacyForm, setAdvocacyForm] = useState<AccountData>();
  const [advocacyList, setAdvocacyList] = useState<SelectItem[]>([]);


  usePageTitle('Личный кабинет адвоката')

  const [getReq] =
    useLazyListenerQuery();
  const fetchLawyerInfo = async () => {
    const lawyerInfo = await getReq({
      path: `/lawyers/personal-account`
    })
    setAdvocacyForm(lawyerInfo.data)
  }

  useEffect(() => {
    fetchLawyerInfo()
  }, [])

  useEffect(() => {
    const getAdvocacy = async () => {
      const advocacy = await getReq({path: `/common-references/type/ADVOCACY_FORM`})
      const newList: any = []

      advocacy.data.map((x: any) => {
        newList.push({
          label: x.title,
          value: x.id,
        })
      })
      setAdvocacyList(newList)
    }
    getAdvocacy();
  }, []);

  return (
    <>
      {
        advocacyForm && (
          <ProfileForm advocacyForm={advocacyForm} advocacyList={advocacyList}/>
        )
      }
    </>
  )
}
